import { connect } from 'react-redux'
import { Component } from "react"
import {isMobile} from 'react-device-detect';
import * as THREE from 'three';
import {
  LoadingOverlay,
  Drawer,
  ActionIcon,
  CloseButton,
  Paper, Indicator, Divider, Modal, ScrollArea
} from "@mantine/core";
import {IconCube, IconXboxX, IconEdit, IconSquareRoundedXFilled, IconDeviceFloppy} from '@tabler/icons-react';
import{ onEditMode, onDetailObject3D } from "../../actions" 
import Listing3DElements from './Listing3D';
import WordObjects from './WordObjects';
import DetailObject from "./DetailObject"



const pathContext = {
    scene3D: null,
    mode: "edit",
    last_version: 0,
    somthing_to_do : {
      edit: ""
    },
    version: 0,
    loading: false,
    toSave: false
}

class Object3DEditor extends Component{
  constructor(props) {
      super(props)
      
      this.state = pathContext
  }

  makeStateCopy(){
    return {
        scene3D: this.state.scene3D,
        mode: this.state.mode,
        somthing_to_do: this.state.somthing_to_do,
        last_version: this.state.last_version,
        version: this.state.version + 1,
        loading: this.state.loading,
        toSave: this.state.toSave,   
    }
}

  componentDidMount() {
    this.props.notification.addNotification("Indicator", async (type, msg, arg)=>{
      let state = this.makeStateCopy()
      if(msg.from === "WordObjects"){
        state.somthing_to_do.edit = msg.value
      }
      this.setState(state)
    })
  }

  toggleAddMode(mode){
    let state = this.makeStateCopy()
    if(state.mode === mode){
        return
    }
    else state.mode = mode
    this.setState(state)
    this.props.notification.onNotification("EditorMode", {from: "Object3DEditor", value: state.mode}, {})
  }

  render() {
      return (
          <>
            <LoadingOverlay visible={this.state.loading} zIndex={1000} overlayProps={{ radius: "sm", blur: 2 }} />
            <Drawer  className={"drawer-3D"} opened={this.props.editMode === "3d"} size={isMobile?"xs":"sm"}
                              overlayProps={{ backgroundOpacity: 0, display:"none" }} withCloseButton={false} style={{"margin": "auto"}}>
                <CloseButton style={{"top": "0rem", "right": "0rem", position: "absolute"}} icon={<IconXboxX size={18} stroke={1.5} />} onClick={()=>this.props.onEditMode("")} />
                <Paper style={{"paddingTop": "2rem", background:"transparent"}} className='ui-element'>
                  <ActionIcon style={{"top": "1.2rem", "right": "2rem", position: "absolute"}} className={this.state.mode === "edit"? "filled" : "default"} variant={this.state.mode === "edit"? "filled" : "default"} aria-label="Settings" onClick={()=>{this.toggleAddMode("edit")}}><IconEdit size={14}/></ActionIcon>
                  <Indicator disabled={this.state.somthing_to_do.edit===""}  label={this.state.somthing_to_do.edit}  style={{"top": "1.2rem", "right": "5rem", position: "absolute"}} color="blue" size={16}>
                  <ActionIcon  className={this.state.mode === "object"? "filled" : "default"} variant={this.state.mode === "object"? "filled" : "default"} aria-label="Settings" onClick={()=>{this.toggleAddMode("object")}}><IconCube size={14}/></ActionIcon>
                  </Indicator>

                  <Divider my="md" />
                </Paper>
                
                
                <Listing3DElements objectsScene={this.props.objectsScene} />
                <WordObjects objectSelection={this.props.objectSelection} objectsScene={this.props.objectsScene} onCreateObjet3DCallback={(e)=>{this.onCreateObjet3D(e)}}/>
                
            </Drawer>
            <Modal centered className={`detail-map${this.props.detailObject3D ? "":" hide"}`}   size="70%" opened={true} onClose={()=>{
              this.props.onDetailObject3D(null, null)
          }} title={`Details pour: ${this.props.detailObject3D ? this.props.detailObject3D.element3d.nom:""}`}>
              <DetailObject element3D={this.props.detailObject3D ? this.props.detailObject3D.element3d: null}   position={this.props.detailObject3D ? this.props.detailObject3D.position: null}/>
          </Modal>
        </>)
  }

}

const mapDispatchToProps = {
  onEditMode: onEditMode,
  onDetailObject3D: onDetailObject3D
}

const mapStateToProps = (state) => {  
    return {
        editMode: state.editMode,
        notification: state.notification,
        detailObject3D: state.detailObject3D
    }
}


Object3DEditor = connect(mapStateToProps, mapDispatchToProps)(Object3DEditor);

export default Object3DEditor;